/**
 * Reusable Types for Amethyst protos. Please fill in as needed
 */
/**
 * https://code.amazon.com/packages/AmethystEvents/blobs/65926bb37e5f98df77f928ff919316f344d880ce/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto
 *
 * This is an incomplete version of the Amethyst Page Types above. As typescript events are added which use them, they should be added below.
 */
export type PageType = 'UNKNOWN_PAGE_TYPE' | 'PRODUCT_PAGE' | 'OUTFIT_DETAIL_PAGE';

/**
 * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/ProductIdentifiers.proto
 */
export type ProductIdentifiers = {
  productId?: string;
  styleId?: string;
  colorId?: string;
  supplementalData?: ProductIdentifierSupplementalData;
};

/**
 * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/ProductIdentifiersSupplementalData.proto
 */
export type ProductIdentifierSupplementalData = {
  isInStock?: boolean;
  price?: number;
};

export type MediaSourceType = 'UNKNOWN_MEDIA_SOURCE_TYPE' | 'CAMERA' | 'DEVICE' | 'INSTAGRAM';

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/ABTestOverride.proto
export type ABTestOverrideEvent = {
  abTestOverride: {
    name: string;
  };
};

/**
 * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/InteractionToCompleteView.proto
 */
export enum InteractionToCompleteViewExperience {
  CART_MODAL_TO_CHECKOUT_LOGIN = 1000,
  CART_MODAL_TO_CHECKOUT_SHIPPING = 1001,
  CART_MODAL_TO_CHECKOUT_PAYMENT = 1002,
  CART_MODAL_TO_CHECKOUT_REVIEW = 1003,
  CHECKOUT_SHIPPING_TO_PAYMENT = 2000,
  CHECKOUT_PAYMENT_TO_REVIEW = 2100
}

export type InteractionToCompleteViewEvent = {
  experience: InteractionToCompleteViewExperience;
  actionTimestamp: number;
  startTimestamp: number;
  infoTimestamp: number;
  imagesTimestamp: number;
};
